import "./index.scss";

export function StatusBar(props: { progress: number }) {
    return (
        <div className="status-bar">
            <div className="status-bar__inner" style={{ width: `${Math.min(100, Math.max(0, props.progress * 100))}%` }}></div>
        </div>
    );
}